// Standardized US phone input. Owns the progressive mask + tel attributes so
// every phone field in the app behaves identically. Forwards className and all
// other input props; masking logic lives in lib/utils (maskUSPhone).

import { maskUSPhone } from '../../lib/utils'

type PhoneInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'value' | 'type'
> & {
  value: string
  onChange: (masked: string) => void
}

export function PhoneInput({ value, onChange, ...rest }: PhoneInputProps) {
  return (
    <input
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      value={value}
      onChange={(e) => onChange(maskUSPhone(e.target.value))}
      {...rest}
    />
  )
}
